import React from 'react'
import './Sales.css'
import { Typography, Paper } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { MatrixGoldIcon, CounterSketchIcon, ClayooIcon, RhinoNestIcon } from '../../constants'

const OptionalRow = function (props: any) {
  const { data, attributeName, mailto, link, productsList, formatName }: any = props
  if (data[attributeName]) {
    return (
      <div className='contact-row'>
        <div className='contact-title'>
          <Typography variant='body2'>{formatName}</Typography>
        </div>
        <div className='contact-content'>
          {mailto ? (
            <Typography>
              <a href={`mailto:${data[attributeName]}`}>{data[attributeName]}</a>
            </Typography>
          ) : link ? (
            <Typography>
              <a href={data[attributeName]} target='_blank' rel='noopener noreferrer'>
                {data[attributeName]}
              </a>
            </Typography>
          ) : productsList ? (
            renderProductList(data[attributeName])
          ) : (
            <Typography>{data[attributeName]}</Typography>
          )}
        </div>
      </div>
    )
  } else {
    return null
  }
}

const renderProductList = (productsList: any) => {
  return productsList.map((item: any, index: number) => {
    switch (item) {
      case 'MatrixGold':
        return <img key={index} src={MatrixGoldIcon} alt={item} title={item} style={{ padding: 6, maxWidth: 30 }} />
      case 'CounterSketch':
      case 'CounterSketch Studio':
        return <img key={index} src={CounterSketchIcon} alt={item} title={item} style={{ padding: 4, maxWidth: 30 }} />
      case 'Clayoo':
        return <img key={index} src={ClayooIcon} alt={item} title={item} style={{ padding: 5, maxWidth: 30 }} />
      case 'RhinoNest':
        return (
          <img
            key={index}
            src={RhinoNestIcon.src}
            alt={item}
            title={item}
            style={{ margin: 5, maxWidth: 30 }}
            width={RhinoNestIcon.width}
            height={RhinoNestIcon.height}
          />
        )
      default:
        return null
    }
  })
}

export default function ContactWorldSellers(props: any) {
  let { ImageUrl, ImageAlt } = props
  if (!ImageUrl) {
    ImageUrl = 'https://meteor.stullercloud.com/das/133564264?fmt=smart-alpha'
  }
  if (!ImageAlt) {
    ImageAlt = 'Authorized Dealer'
  }

  return (
    <Paper className='contact-wrapper' data-cy='contact-container'>
      <div className='sales-contact-image'>
        <img src={ImageUrl} alt={ImageAlt} />
      </div>
      <div className='contact-text'>
        <OptionalRow data={props} attributeName='NameCompany' formatName={<FormattedMessage id='account.company' />} />
        <OptionalRow data={props} attributeName='Contact' formatName={<FormattedMessage id='account.contact' />} />
        <OptionalRow data={props} attributeName='Email' mailto formatName={<FormattedMessage id='account.email' />} />
        <OptionalRow data={props} attributeName='PhoneNumber' formatName={<FormattedMessage id='account.phone' />} />
        <OptionalRow data={props} attributeName='Address' formatName={<FormattedMessage id='account.address' />} />
        <OptionalRow
          data={props}
          attributeName='ProductsList'
          productsList
          formatName={<FormattedMessage id='account.products' />}
        />
        <OptionalRow data={props} attributeName='Url' link formatName={<FormattedMessage id='account.website' />} />
      </div>
    </Paper>
  )
}
